import { Injectable } from '@angular/core';
import { Event } from './event';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { tokenNotExpired } from 'angular2-jwt';

import { AppSettings } from '../app-settings';

import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class EventService {

  public token: string;

  headers = new Headers({ 'Accept': 'application/json' });
  options = new RequestOptions({ headers: this.headers });

  constructor(private http: Http, private authHttp: AuthHttp) {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  getDashBoard(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/admin/dash-board", params, this.options).map(response => response.json());
  }

  getEvents(params): Observable<any> {
    return this.http.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/list", params, this.options).map(response => response.json().events);
  }

  getEventsWithPackages(params): Observable<any> {
    return this.http.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/get_with_packages", params, this.options).map(response => response.json().events);
  }

  saveEvent(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/add", params, this.options).map(response => response.json());
  }

  deleteEvent(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/delete", params, this.options).map(response => response.json());
  }

  isDuplicate(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/is_duplicate", params, this.options).map(response => response.json());
  }

  getAdminContactList(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/admin/get-contact-list", params, this.options).map(this.extractData)
      .catch(this.handleError);
  }

  registrationMonths(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/registration-months", params, this.options).map(response => response.json());
  }

  signUps(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/sign-ups", params, this.options).map(response => response.json());
  }

  getCategoryList(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/admin/get-category-list", params, this.options).map(response => response.json());
  }

  categoryAdd(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/admin/category-update", params, this.options).map(response => response.json());
  }

  blockUnblockCat(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/admin/category-block-unblock", params, this.options).map(response => response.json());
  }

  getBenefits(params): Observable<any> {
    return this.http.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/get-benefits", params, this.options).map(response => response.json().benefits);
  }

  saveBenefits(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/save-benefits", params, this.options).map(response => response.json());
  }

  cancelTravel(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/cancel-travel-info", params, this.options).map(response => response.json());
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || [];
  }

  private handleError(error: Response | any) {
    return Observable.throw(<any>error);
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/event.service.ts